import React from 'react'
import { ArrowLongRightIcon } from '@heroicons/react/20/solid'
import { TooltipIcon } from './TooltipIcon'

interface CtaCardProps {
  title?: 'callback' | 'continue'
  tooltip?: string
  children?: React.ReactNode
  type?: 'button' | 'submit' | 'reset'
  onClick?: () => void
}

const CtaCard: React.FC<CtaCardProps> = ({ title, tooltip, children, type = 'button', onClick, ...props }) => {
  return (
    <div className='relative max-w-[220px] w-[220px] grow'>
       {tooltip &&
        <span className='block absolute top-2.5 right-1 z-10'>
          <TooltipIcon id='tooltip-holder' content={tooltip} />
        </span>
      }
      <button
        {...props}
        type={type}
        onClick={onClick}
        className='
          group cursor-pointer w-full h-full will-change-transform flex flex-col gap-10 items-center text-center
          transition duration-500 text-[var(--loan-type-text)] rounded-[4px] bg-[var(--loan-type-bg)] px-7 py-6
          [@media(hover:hover)]:hover:bg-[var(--loan-type-bg-hover)] [@media(hover:hover)]:hover:text-[var(--loan-type-text-hover)] [@media(hover:hover)]:hover:scale-[1.1]
      '>
        { children && 
          <div className='size-[124px] flex items-center transition duration-500 justify-center bg-[var(--loan-type-icon-bg)] mx-auto rounded-full text-[var(--loan-type-icon)] [@media(hover:hover)]:group-hover:text-[var(--loan-type-icon-hover)] [@media(hover:hover)]:group-hover:bg-[var(--loan-type-icon-bg-hover)]'>
            {children}
          </div>
        }
        <span className='flex flex-col items-center gap-1'>
          {title === 'callback' && <span className='text-xl font-[var(--font-weight-bold)] text-balance px-0.5'>Request<br /> call back</span>}
          {title === 'continue' && <span className='text-xl font-[var(--font-weight-bold)] text-balance px-0.5'>Continue application online</span>}
          <ArrowLongRightIcon aria-hidden='true' className='size-7' />
        </span>
      </button>
    </div>
  )
}

export {CtaCard}